/* ============================================================
   pf-section-skeleton.js
   Shared skeleton-hide helper. A section renders a `.pf-skel` overlay
   (shimmer blocks matching its real layout) visible by default, then
   calls initPfSkeleton() once its DOM is wired up. The overlay fades out
   once every tracked image has loaded (or errored), with a timeout
   fallback so a slow/broken image never leaves it stuck.

   Usage, once the section's root element is in scope:
     initPfSkeleton(root, root.querySelectorAll('img'));
   Pass only the images that actually gate this section's "looks ready"
   moment (e.g. the main hero image) — not every thumbnail — so the
   skeleton clears as soon as the visible content is in place.
   ============================================================ */
function initPfSkeleton(rootEl, images, opts) {
  if (!rootEl) return;
  var skel = rootEl.querySelector('.pf-skel');
  if (!skel) return;
  var timeoutMs = (opts && opts.timeoutMs) || 5000;
  var hidden = false;

  function hide() {
    if (hidden) return;
    hidden = true;
    skel.classList.add('pf-skel-hidden');
  }

  var imgList = images ? Array.prototype.slice.call(images) : [];
  var pending = imgList.filter(function (img) { return !img.complete; }).length;

  if (pending === 0) {
    hide();
  } else {
    imgList.forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        pending -= 1;
        if (pending <= 0) hide();
      }, { once: true });
      img.addEventListener('error', function () {
        pending -= 1;
        if (pending <= 0) hide();
      }, { once: true });
    });
  }

  window.setTimeout(hide, timeoutMs);
}
